import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { FormDateField } from '~/modules/common/components';
import { isoStringToObjectWithCache as isoStringToObject } from '~/modules/common/dates/convert';
import { useMeContext } from '~/modules/me';

const useV5DatePickerClasses = makeStyles(theme => ({
  input: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'bold !important'
  }
}));

export const ResourceRequestDrawerDetailsDateField = ({
  date,
  classes,
  onChange,
  error,
  labelId
}) => {
  const { formatMessage } = useIntl();
  const {
    featureFlags: { isPsaRmp2025Q4WcagEnabled }
  } = useMeContext();
  const v5DatePickerClasses = useV5DatePickerClasses();

  const dateProps = useMemo(
    () => ({
      inputProps: {
        'aria-label': formatMessage({
          id: labelId
        }),
        className: classes.dateField
      }
    }),
    [classes.dateField, formatMessage, labelId]
  );

  const v5DatePickerProps = isPsaRmp2025Q4WcagEnabled
    ? {
        useV5DatePicker: true,
        v5DatePickerClasses
      }
    : {};

  return (
    <FormDateField
      required
      editable
      InputProps={dateProps}
      label={formatMessage({
        id: labelId
      })}
      error={error}
      helperText={date.error}
      flex="shrink"
      underline={false}
      clearable={false}
      value={isoStringToObject(date.value)}
      onChange={onChange}
      {...v5DatePickerProps}
    />
  );
};

ResourceRequestDrawerDetailsDateField.propTypes = {
  date: PropTypes.object,
  classes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  labelId: PropTypes.string,
  error: PropTypes.bool
};

export default ResourceRequestDrawerDetailsDateField;
